import { createSlice } from "@reduxjs/toolkit";

import type {
  IFocusedTileGroup,
  IFocusedVisualizationTile,
  ISingleViewTile,
  ITileGroup,
  IVisualizationTileGroup,
} from "../../types";

export const initialState: {
  gameTiles: ITileGroup;
  hittingTiles: ITileGroup;
  pitchingTiles: ITileGroup;
  visualizationTiles: IVisualizationTileGroup;
  focusedViewTiles: IFocusedTileGroup;
  focusedVisualizationTile: IFocusedVisualizationTile;
  singleViewTile: ISingleViewTile;
} = {
  gameTiles: {
    tileOne: { type: "data", title: "Velocity", hidden: false },
    tileTwo: { type: "data", title: "Spin Rate", hidden: false },
    tileThree: { type: "data", title: "Efficiency", hidden: false },
    tileFour: { type: "data", title: "Tilt", hidden: false },
    tileFive: { type: "data", title: "I. Vert Break", hidden: false },
    tileSix: { type: "data", title: "Horz Break", hidden: false },
    tileSeven: { type: "data", title: "Exit Velo", hidden: false },
    tileEight: { type: "data", title: "Launch Angle", hidden: false },
    tileNine: { type: "data", title: "Distance", hidden: false },
  },
  hittingTiles: {
    tileOne: { type: "data", title: "Exit Velo", hidden: false },
    tileTwo: { type: "data", title: "Launch Angle", hidden: false },
    tileThree: { type: "data", title: "Distance", hidden: false },
    tileFour: { type: "data", title: "Direction", hidden: false },
    tileFive: { type: "data", title: "Hang Time", hidden: false },
    tileSix: { type: "data", title: "Bat'd Spin Rate", hidden: false },
    tileSeven: { type: "data", title: "Exit Velo", hidden: false },
    tileEight: { type: "data", title: "Launch Angle", hidden: false },
    tileNine: { type: "data", title: "Distance", hidden: false },
  },
  pitchingTiles: {
    tileOne: { type: "data", title: "Velocity", hidden: false },
    tileTwo: { type: "data", title: "Spin Rate", hidden: false },
    tileThree: { type: "data", title: "Efficiency", hidden: false },
    tileFour: { type: "data", title: "Tilt", hidden: false },
    tileFive: { type: "data", title: "Vert Break", hidden: false },
    tileSix: { type: "data", title: "I. Vert Break", hidden: false },
    tileSeven: { type: "data", title: "Horz Break", hidden: false },
    tileEight: { type: "data", title: "Rel Height", hidden: false },
    tileNine: { type: "data", title: "Rel Side", hidden: false },
  },
  visualizationTiles: {
    tileOne: {
      type: "visualization",
      visualization: "StrikeZone",
      hidden: false,
    },
    tileTwo: { type: "visualization", visualization: "Landing", hidden: false },
    tileThree: {
      type: "visualization",
      visualization: "Contact",
      hidden: false,
    },
  },
  focusedViewTiles: {
    tileOne: { type: "data", title: "Velocity", hidden: false },
    tileTwo: { type: "data", title: "Spin Rate", hidden: false },
    tileThree: { type: "data", title: "Exit Velo", hidden: false },
    tileFour: { type: "data", title: "Distance", hidden: false },
  },
  focusedVisualizationTile: {
    tile: { type: "visualization", visualization: "StrikeZone", hidden: false },
  },
  singleViewTile: {
    tile: { type: "data", title: "Velocity", hidden: false },
  },
};

const tileSlice = createSlice({
  name: "tiles",
  initialState,
  reducers: {
    setGameTiles: (state, action) => {
      state.gameTiles = action.payload;
    },
    setPitchingTiles: (state, action) => {
      state.pitchingTiles = action.payload;
    },
    setHittingTiles: (state, action) => {
      state.hittingTiles = action.payload;
    },
    setVisualizationTiles: (state, action) => {
      state.visualizationTiles = action.payload;
    },
    setFocusedViewTiles: (state, action) => {
      state.focusedViewTiles = action.payload;
    },
    setFocusedVisualizationTile: (state, action) => {
      state.focusedVisualizationTile = action.payload;
    },
    setSingleViewTile: (state, action) => {
      state.singleViewTile = action.payload;
    },
    resetTiles: (state, action) => {
      if (action.payload === "pitching") {
        return (state = {
          ...state,
          pitchingTiles: initialState.pitchingTiles,
        });
      }
      if (action.payload === "hitting") {
        return (state = {
          ...state,
          hittingTiles: initialState.hittingTiles,
        });
      }
      if (action.payload === "game") {
        return (state = {
          ...state,
          gameTiles: initialState.gameTiles,
        });
      }
      if (action.payload === "visualization") {
        return (state = {
          ...state,
          visualizationTiles: initialState.visualizationTiles,
        });
      }
      if (action.payload === "focused") {
        return (state = {
          ...state,
          focusedViewTiles: initialState.focusedViewTiles,
        });
      }
      if (action.payload === "focusedVisualization") {
        return (state = {
          ...state,
          focusedVisualizationTile: initialState.focusedVisualizationTile,
        });
      }
      if (action.payload === "single") {
        return (state = {
          ...state,
          singleViewTile: initialState.singleViewTile,
        });
      }
    },
  },
});

export const {
  setGameTiles,
  setHittingTiles,
  setPitchingTiles,
  setVisualizationTiles,
  setFocusedViewTiles,
  setFocusedVisualizationTile,
  setSingleViewTile,
  resetTiles,
} = tileSlice.actions;
export default tileSlice.reducer;
